export type ConsumerApiErrorDetail =
    | {
          code: "AVAILABILITY_LIST";
          productId: string;
          startDate: string;
          endDate: string;
          errorMessage?: string;
          requestId: string | undefined;
      }
    | {
          code: "AVAILABILITY";
          availabilityId: string;
          errorMessage?: string;
          requestId: string | undefined;
      }
    | {
          code: "CREATE_BOOKING";
          availabilityId: string;
          errorMessage?: string;
          requestId: string | undefined;
      }
    | {
          code: "BOOKING_ADD_AVAILABILITY";
          bookingId: string;
          availabilityId: string;
          errorMessage?: string;
          requestId: string | undefined;
      };

export class ConsumerApiError extends Event {
    static NAME = "consumer:api-error";

    constructor(readonly details: ConsumerApiErrorDetail) {
        super(ConsumerApiError.NAME, {
            bubbles: true,
            cancelable: false,
        });
    }
}
